import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {EntityContainerModel} from '../../../../../../models/aggregates/erp/entity';
import {ApiVisa, BaseApiTemplateService, BasicApiResponseModel, Pagination, PagingResponseModel} from '../../shared';
import {Core2Config} from '../../shared';
import {Observable} from "rxjs";
import { LoginEntityUpdateRequestDtoModel } from '../../../data-transfer-objects';

@Injectable({providedIn: 'root'})
export class EntityLoginEpService extends BaseApiTemplateService<EntityContainerModel> {

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX  +  Core2Config.ERP_PREFIX + 'entity/login-entity-ep';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'entity/login-entity-ep';
    this.httpClient = http;
  }

  public getLoginEntityByGuid(
    guid: string,
    visa: ApiVisa
  ): Observable<BasicApiResponseModel<EntityContainerModel>> {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
    }
    return this.httpClient.get<BasicApiResponseModel<EntityContainerModel>>(
      this.apiUrl + '/' + guid,
      this.getHttpHeader(visa)
    );
  }

  public updateLoginEntity(dtoObject: LoginEntityUpdateRequestDtoModel, visa: ApiVisa): Observable<BasicApiResponseModel<EntityContainerModel>> {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
    }
    return this.httpClient.put<BasicApiResponseModel<EntityContainerModel>>(
      this.apiUrl,
      dtoObject,
      this.getHttpHeader(visa)
    );
  }
  
}
